import { render, staticRenderFns } from "./LookDetail.vue?vue&type=template&id=670d1b78&scoped=true"
import script from "./LookDetail.vue?vue&type=script&lang=js"
export * from "./LookDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d1b78",
  null
  
)

export default component.exports